let appInstance = null;

export function setApp(app) {
  appInstance = app;
}

export function getApp() {
  if (!appInstance) {
    console.warn("⚠️ App Vue não inicializado ainda!");
  }
  return appInstance;
}

export function toastMessage(severity, summary, detail, life = 5000) {
  if (!appInstance) {
    console.warn("App não inicializado para usar Toast!");
    alert(`[${severity.toUpperCase()}] ${summary}\n${detail}`); // fallback
    return;
  }

  appInstance.config.globalProperties.$toast.add({
    severity,
    summary,
    detail,
    life,
  });
}


export function confirm(message, header, rejectLabel, acceptLabel, rejectClass, acceptClass) {
    if (!appInstance) {
        console.error("⚠️ App Vue não inicializado em funcoes.js");
    }

}

